var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.51,
    height: 19.215,
    viewBox: "0 0 13.51 19.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#21314b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4144",
    transform: "translate(76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    d: "M82.755 0a6.756 6.756 0 0 0-5.747 10.307l5.362 8.641a.563.563 0 0 0 .478.266.563.563 0 0 0 .478-.274l5.226-8.725A6.757 6.757 0 0 0 82.755 0zm4.836 9.638L82.84 17.57l-4.875-7.856a5.633 5.633 0 1 1 9.626-.076z",
    className: "cls-1",
    transform: "translate(-76)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4146",
    transform: "translate(79.378 3.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    d: "M169.378 90a3.378 3.378 0 1 0 3.378 3.378A3.381 3.381 0 0 0 169.378 90zm0 5.637a2.259 2.259 0 1 1 2.255-2.259 2.261 2.261 0 0 1-2.255 2.259z",
    className: "cls-1",
    transform: "translate(-166 -90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteData);
export default __webpack_public_path__ + "static/media/site-data.b236a1973bb962c58fe0bf0be63f133e.svg";
export { ForwardRef as ReactComponent };